import React from "react";
import {
  FaFacebookF,
  FaGithub,
  FaLinkedinIn,
  FaInstagram,
  FaWhatsapp,
  FaPhoneAlt,
} from "react-icons/fa";
const SocialIcons = () => {
  return (
    <>
      <div className="social_icons fade-in-up">
        <FaGithub
          className="social-icon"
          onClick={() => {
            window.open("https://github.com/Priyanshu8130");
          }}
        />
        <FaLinkedinIn
          className="social-icon"
          onClick={() => {
            window.open(
              "https://www.linkedin.com/in/priyanshu-kushwaha-1b7172186/"
            );
          }}
        />
        <FaFacebookF
          className="social-icon"
          onClick={() => {
            window.open("https://www.facebook.com/priyanshu.kushwah.1/");
          }}
        />
        <FaPhoneAlt
          gram
          className="social-icon"
          onClick={() => {
            window.location.href = "tel:+917500058993";
          }}
        />
        <FaWhatsapp
          className="social-icon"
          onClick={() => {
            window.open("https://wa.me/917500058993");
          }}
        />
      </div>
    </>
  );
};

export default SocialIcons;
